import React from "react";
import { Link, graphql } from "gatsby"

// Components
import { Page, Container } from "components/core/layout";
import { WebsiteHeader } from "components/core/seo"
import { Code } from "components/core/code";
import { Card, ClickCard, CardLayout } from "components/core/cards";
import * as Run  from "components/api/run";
import * as Config  from "components/api/config";
import * as ConfigTemplate  from "components/api/config_template";
import * as Pyhectiqlab  from "components/api/pyhectiqlab";

import { TableOfContent } from 'components/core/table_of_content'; 
import { MDXProvider } from "@mdx-js/react";
import { MDXRenderer } from "gatsby-plugin-mdx";
// MDX components
const shortcodes = { Link, pre: Code, ...Run, ...Config, ...Pyhectiqlab, ...ConfigTemplate, Card, CardLayout, ClickCard } 

/*
 URL: /:section/:subsection 
*/
export default function Index({data: {mdx, site}, location }){
  return <Page location={location}>
           <WebsiteHeader
              url={`${site.siteMetadata.siteURL}${location.pathname}`}
              title={mdx.headings[0].value||site.siteMetadata.title}
              description={site.siteMetadata.title}
              twitter={site.siteMetadata.twitter}
            />
          <Page.Primary>
            <Container>
              <div className='mdx-content mb-6 my-2 lg:my-16 lg:px-12 whitespace-pre-line '>
                <span className="field-source capitalize font-medium text-blue-800">{mdx.fields.source.replace("_", " ")}</span>
                <div className="space-y-3">
                  <MDXProvider components={shortcodes}>
                    <MDXRenderer frontmatter={mdx.frontmatter}>{mdx.body}</MDXRenderer>
                  </MDXProvider>
                </div>
              </div>
            </Container>
          </Page.Primary>
          <Page.Secondary>
            <TableOfContent tableOfContents={mdx.tableOfContents}/>
          </Page.Secondary>
          </Page>;
}


/*
  Fetch the data for the given page. See gatsby_node.js for context.
*/
export const query = graphql`
  query DocQuery($id: String) {
    site {
      siteMetadata {
        siteUrl
        title
        description
      }
    }
    mdx(id: { eq: $id }) {
      id
      body
      headings(depth: h1) {
        value
      }
      tableOfContents(maxDepth: 10)
      fields {
        source
      }
      frontmatter {
        title
      }
    }
  }
`